import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { FieldType } from '@uno/common-cms';
// TODO: Unit test
export var prefixField = function prefixField(field, namePrefix, id, defaultValues) {
  if (field.type === FieldType.Repeatable) {
    throw new Error('Repeatable fields cannot be nested yet !');
  }

  var keyPrefix = "".concat(id, ".");
  var defaultValue = field.type !== FieldType.Group ? getDefaultValue(defaultValues, id, field.name) : undefined;
  return _objectSpread(_objectSpread({}, field), {}, {
    name: "".concat(namePrefix).concat(field.name),
    key: "".concat(keyPrefix).concat(field.name),
    defaultValue: defaultValue,
    fields: field.type === FieldType.Group ? field.fields.map(function (groupField) {
      return prefixField(groupField, namePrefix, id, defaultValues);
    }) : undefined
  });
};

var getDefaultValue = function getDefaultValue(defaultValues, id, fieldName) {
  var field = defaultValues.find(function (item) {
    return item.id === id;
  });
  return field !== undefined ? field[fieldName] : undefined;
};